import React from 'react';

export type SpinnerProps = {
  size?: number;
  color?: string;
};

export function Spinner({ size = 16, color = 'currentColor' }: SpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ animation: 'dpSpin 0.9s linear infinite' }}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2.4" fill="none" opacity=".18" />
      <path d="M12 3a9 9 0 0 1 9 9" stroke={color} strokeWidth="2.4" fill="none" strokeLinecap="round" />
      <style>{`@keyframes dpSpin { to { transform: rotate(360deg); } }`}</style>
    </svg>
  );
}

export default Spinner;
